module.exports = __webpack_public_path__ + "img/big-hotsale.70c1c4f1.png";